import { useTranslation } from 'react-i18next';
import { Card } from '../../shared/Card/Card';
import { CardHeaderSkeleton } from '../../shared/CardHeader/CardHeaderSkeleton';
import { Shimmer } from '../../shared/Shimmer/Shimmer';
import styles from './ConfidenceMixSkeleton.module.css';

/** Loading state for {@link ConfidenceMix} — the four bands, plus the note. */
export function ConfidenceMixSkeleton() {
  const { t } = useTranslation();
  return (
    <Card aria-busy="true" aria-label={t('productivity.skeleton.loading')}>
      <CardHeaderSkeleton size="sm" />
      <div className={styles.bands}>
        {Array.from({ length: 4 }, (_, i) => (
          <div key={i} className={styles.band}>
            <div className={styles.bandTop}>
              <Shimmer className={styles.bandLabel} wave={i * 0.06} />
              <Shimmer className={styles.bandPct} wave={i * 0.06} />
            </div>
            <Shimmer className={styles.track} wave={i * 0.06} />
          </div>
        ))}
      </div>
      <Shimmer className={styles.note} />
    </Card>
  );
}
